import { ReactComponent as CloseSvg } from "../../assets/icons/close.svg";
import {
  ModalContainer,
  CloseButton,
  ModalContent,
  ModalTitle,
  ModalMessage,
  ButtonGroup,
  CancelButton,
  ConfirmButton,
  Row,
} from "./TextModal.styles";
import Modal from "../utils/Modal/Modal";
import { useLockBodyScroll } from "../../hooks/useLockBodyScroll";

const TextModal = ({
  isOpen,
  onClose,
  title,
  onConfirm,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmButtonType = "danger",
  hideButtons,
  isLoading = false,
}) => {
  useLockBodyScroll(isOpen);

  const handleConfirm = () => {
    onConfirm();
  };

  const handleCancel = () => {
    if (!isLoading) {
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      customOverlayStyles={{ zIndex: 3100 }}
    >
      <ModalContainer>
        <ModalContent>
          <Row>
            <ModalTitle>{title}</ModalTitle>
            <CloseButton onClick={handleCancel}>
              <CloseSvg width={20} height={20} />
            </CloseButton>
          </Row>
          <ModalMessage>{message}</ModalMessage>
          {!hideButtons && (
            <ButtonGroup>
              <CancelButton onClick={handleCancel} disabled={isLoading}>
                {cancelText}
              </CancelButton>
              <ConfirmButton
                onClick={handleConfirm}
                $type={confirmButtonType}
                disabled={isLoading}
              >
                {isLoading ? (
                  <l-line-spinner size="20" stroke="2" speed="1" color="#fff" />
                ) : (
                  confirmText
                )}
              </ConfirmButton>
            </ButtonGroup>
          )}
        </ModalContent>
      </ModalContainer>
    </Modal>
  );
};

export default TextModal;
